import ChevronRight from "@assets/svg/ChevronRight";
import CustomText from "@components/CustomText";
import CrateItem from "@screens/CustomerOrderItems/components/CrateCard";
import React, { useState } from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";

function CrateGroup({
  crate_id,
  items,
  markingConfig,
  fetchData,
  imagesMandatoryForSamasya,
  isOfdCp,
  forceExpanded = false,
}) {
  const [expanded, setExpanded] = useState(false);
  const isOpen = forceExpanded || expanded;

  return (
    <View style={styles.wrapper}>
      <TouchableOpacity
        testID={`crate_group_${crate_id}`}
        activeOpacity={0.7}
        onPress={() => setExpanded((p) => !p)}
        style={styles.header}
      >
        <CustomText variant="body_text_2" style={styles.headerText}>
          {`क्रेट : ${crate_id}`}
        </CustomText>
        <View
          style={[
            styles.chevron,
            { transform: [{ rotate: isOpen ? "270deg" : "90deg" }] },
          ]}
        >
          <ChevronRight
            pathFill="rgba(0, 0, 0, 0.56)"
            width={14}
            height={14}
          />
        </View>
      </TouchableOpacity>
      {isOpen
        ? items.map((item) => (
            <View
              key={`${crate_id}_${item?.order_item_id || item?.id}`}
              style={styles.itemContainer}
            >
              <CrateItem
                info={item}
                markingConfig={markingConfig}
                fetchData={fetchData}
                imagesMandatoryForSamasya={imagesMandatoryForSamasya}
                isOfdCp={isOfdCp}
                type="CRATE"
                hideCrateId
              />
            </View>
          ))
        : null}
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    marginHorizontal: 12,
    marginTop: 8,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    borderRadius: 10,
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  headerText: {
    color: "rgba(0, 0, 0, 0.86)",
  },
  chevron: {
    width: 14,
    height: 14,
    alignItems: "center",
    justifyContent: "center",
  },
  itemContainer: {
    backgroundColor: "white",
  },
});

export default CrateGroup;
